import React, { useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { AdminButton } from "../buttons/versionHistoryBtn";
import "./modal.css";

const SkipModal = ({ show, handleClose, skipFnc, titel = "" }) => {
  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName="skip-modal col-10 px-5 mx-auto"
        contentClassName="skip-modal"
        size="md"
      >
        <ModalBody className="text-nowrap">
          <div className="px-3 py-3 mx-2">
            <p className="fn_Nunito fw_700 fs_18 color_262c3d my-2 px-0">
              Are you sure ?
            </p>
            <p className="fn_Nunito fw_400 fs_16 color_747f9e my-2 text-wrap">
              Do you want to skip {titel}?
            </p>
          </div>
          <div className="d-flex justify-content-center my-3 gap-3">
            <AdminButton
              width="150px"
              background="#E7E5FF"
              color="#7065E4"
              type="button"
              onClick={() => skipFnc()}
            >
              <span className="m-2 fw_700">SKIP</span>
            </AdminButton>

            <AdminButton
              width="150px"
              color="#FF6F5B"
              border="1px solid #FF6F5B"
              type="button"
              onClick={() => handleClose()}
            >
              <span className="m-1">CLOSE</span>
            </AdminButton>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SkipModal;
